export { default } from './CardFolderTabs.js';
